import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { STUDENT_TAB, TabItem } from '@shared/models/tabs-constant';
import { selectUrl } from 'thkee-common';

@Component({
  selector: 'app-student-header',
  templateUrl: './student-header.component.html',
  styleUrls: ['./student-header.component.scss'],
  standalone: true,
  imports: [NgIf, NgFor, NgClass, RouterLink, AsyncPipe],
})
export class StudentHeaderComponent implements OnInit {
  @Input() title: string = $localize`My Classes`;
  @Input() tabItems: TabItem[] = STUDENT_TAB;
  activeRoute$ = this.store.select(selectUrl);

  constructor(private readonly store: Store) {}

  ngOnInit(): void {}
}
